import { Card, CardContent, Chip, Stack, Typography } from "@mui/material";
import { useGetStudentsQuery } from "../../services/students.service";
import { useAppTheme } from "../../context/ThemeContext";

function CommissionCard() {
  const { data: students } = useGetStudentsQuery("Students");
  const { isNewTheme } = useAppTheme();

  const total = (students ?? []).reduce(
    (sum, s) => sum + (Number((s as any).commission) || 0),
    0
  );
  const pending = (students ?? []).filter(
    (s) => s.status === "commission:pending" && (s as any).commission > 0
  ).length;

  const formatted = new Intl.NumberFormat("en-MY", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(total);

  return (
    <Card
      sx={
        isNewTheme
          ? {
              maxWidth: "100%",
              width: "100%",
              borderRadius: "8px",
              border: "1px solid #E2E8F0",
              borderTop: "3px solid #059669",
              boxShadow: "0 2px 6px rgba(15,23,42,0.05)",
              transition: "box-shadow 0.15s ease, transform 0.15s ease",
              "&:hover": { boxShadow: "0 4px 16px rgba(15,23,42,0.07)", transform: "translateY(-1px)" },
            }
          : {
              maxWidth: "100%",
              width: "100%",
              borderRadius: "10px",
              boxShadow: "0px 0px 55px 5px rgba(0, 0, 0, 0.05)",
            }
      }
    >
      <CardContent sx={{ p: isNewTheme ? 2.5 : 2 }}>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Total Commission
        </Typography>
        <Stack direction="column" spacing={isNewTheme ? 1.5 : 2} alignItems="flex-start" mt={isNewTheme ? 1 : 0}>
          <Typography
            variant={isNewTheme ? "h4" : "h5"}
            component="div"
            fontWeight={isNewTheme ? 700 : "semibold"}
            sx={{ lineHeight: 1, fontSize: "1.5rem !important", color: "#059669" }}
          >
            RM {formatted}
          </Typography>
          {pending > 0 ? (
            <Chip
              label={`${pending} pending`}
              size="small"
              color="warning"
              sx={{ borderRadius: isNewTheme ? "4px" : "5px", fontWeight: isNewTheme ? 600 : 400 }}
            />
          ) : (
            <Chip
              label="All collected"
              size="small"
              color="success"
              sx={{ borderRadius: isNewTheme ? "4px" : "5px", fontWeight: isNewTheme ? 600 : 400 }}
            />
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}

export default CommissionCard;
